import childOne from './fixtures/examples-oliver-brown.json'

export default childOne;